<template>
    <ui-modal :title="`Remote invite to ${invite.email}`" :close="close" close-button="Close">
        <p v-if="invite.status_summary" class="-mt-2 text-sm text-gray-500">
            {{ invite.status_summary | capitalize }}
        </p>
        <ui-data-grid class="mt-6">
            <ui-data-grid-item label="Email" :value="invite.email"></ui-data-grid-item>
            <ui-data-grid-item label="Invited By" :value="invite.invited_by"></ui-data-grid-item>
            <ui-data-grid-item v-if="invite.view_records.length > 0" label="Activity" wide>
                <ul class="bg-gray-50 border border-gray-200 rounded-md p-3 space-y-3">
                    <li v-for="(record, index) in invite.view_records" :key="index" class="flex items-start text-sm text-gray-500">
                        <i class="fas fa-eye fa-fw text-gray-400 flex-shrink-0 text-sm mr-1.5 mt-1"></i>
                        <div class="flex-1">
                            <ui-dropdown-date :moment="parseMoment(record.viewed_at)" menu-class="p-3 w-52" #default="{ open, close, dateAgo }">
                                <p class="inline-block font-semibold" @mouseenter="open" @mouseleave="close">Viewed {{ dateAgo }}</p>
                            </ui-dropdown-date>
                            <p>{{ record.ip }} • {{ record.header }}</p>
                        </div>
                    </li>
                </ul>
            </ui-data-grid-item>
        </ui-data-grid>
        <template #footer-primary>
            <ui-button-new v-if="invite.revoked" warning class="w-full" :loading="unrevokeForm.busy" @click="unrevokeForm.submit()">Unrevoke</ui-button-new>
            <ui-button-new v-else danger class="w-full" :loading="revokeForm.busy" @click="revokeForm.submit()">Revoke</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { parseMoment } from '@utils'

export default {
    props: {
        close: Function,
        invite: Object,
    },
    data () {
        return {
            revokeForm: new Form({}, async () => {
                await this.invite.revoke()

            }),
            unrevokeForm: new Form({}, async () => {
                await this.invite.unrevoke()

            }),
        }
    },
    methods: {
        parseMoment,
    },
}
</script>
